import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { BRIEFS_QUERY_KEYS } from '@/entities/brief';
import { TRACKER_QUERY_KEYS, type TrackerBoardType } from '@/entities/tracker';
import { useCurrentWorkspaceId } from '@/entities/workspace';

/**
 * Refetches the rows a board is showing, keeping the current ones on screen
 * while it does: each board renders its loading state only before its first
 * rows arrive, so an invalidation refetches in the background.
 */
export function useRefreshBoardRows(trackerId: string, boardType: TrackerBoardType) {
  const queryClient = useQueryClient();
  const workspaceId = useCurrentWorkspaceId() ?? '';

  return useCallback(() => {
    const queryKey =
      boardType === 'free_form'
        ? TRACKER_QUERY_KEYS.items(workspaceId, trackerId)
        : boardType === 'briefs'
          ? BRIEFS_QUERY_KEYS.allByWorkspace(workspaceId)
          : TRACKER_QUERY_KEYS.allRows(workspaceId, trackerId);
    void queryClient.invalidateQueries({ queryKey });
  }, [queryClient, workspaceId, trackerId, boardType]);
}
